<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 11:27:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/components/HistoryList/index.vue
-->
<template>
  <div class="his_list">
    <div class="top_title">
      <div class="font14 font_weight500 colo087">历史搜索</div>
      <img
        src="@/assets/mine/icon_delete@2x.png"
        alt=""
        class="del_icon"
        @click="deleteHis"
      />
    </div>
    <div class="list">
      <div
        v-for="(i, index) in searchKeys"
        :key="index"
        class="font12 font_weight400 colo087 list_item"
        @click="clickHistoryItem(i)"
      >
        {{ i }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searchKeys: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  // computed: {
  //   searchKeys() {
  //     const searchKeys = this.$store.getters.searchKeys.filter(
  //       item => item !== null && item !== ""
  //     );
  //     return searchKeys;
  //   }
  // },
  methods: {
    deleteHis() {
      this.$emit("deleteHis");
    },
    clickHistoryItem(keywords) {
      this.$emit("clickHistoryItem", keywords);
    }
  }
};
</script>
<style lang="less" scoped>
.his_list {
  padding: 18px 12px 0;
  background: #fff;
  .top_title {
    display: flex;
    justify-content: space-between;
  }
  .del_icon {
    width: 16px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    padding: 18px 12px 0;
    .list_item {
      background: #f4f5f9;
      border-radius: 2px;
      padding: 0 12px;
      line-height: 30px;
      margin: 0 12px 8px 0;
    }
  }
}
</style>
